/**
 * Helper para gerenciar a preferência de desativar resumo e insights da IA
 * Armazenada apenas no localStorage do navegador
 */

const STORAGE_KEY = "smartfile_disable_ai";

/**
 * Verifica se a IA está desabilitada (resumo e insights)
 * @returns true se a IA deve ser desabilitada, false caso contrário
 */
export function isAIDisabled(): boolean {
  if (typeof window === "undefined") return false;
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === "true";
}

/**
 * Define se a IA deve ser desabilitada
 * @param disabled true para desabilitar, false para habilitar
 */
export function setAIDisabled(disabled: boolean): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, String(disabled));
}

